import { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

const Usuarios = () => {
  const [usuarios] = useState([
    {
      id: 1,
      nombre: 'Vincenzo Lucchesi',
      email: 'vincenzo@panto.com',
      empresa: 'Panto Group',
      rol: 'user',
      status: 'active',
      fechaCreacion: '10/3/2025'
    },
    {
      id: 2,
      nombre: 'Carlos',
      email: 'carlos@gmail.com',
      empresa: 'P&G',
      rol: 'user',
      status: 'active',
      fechaCreacion: '10/3/2025'
    },
    {
      id: 3,
      nombre: 'Sandra',
      email: 'sandra.cespedes@ajegroup.com',
      empresa: 'AJE',
      rol: 'user',
      status: 'active',
      fechaCreacion: '4/3/2025'
    },
    {
      id: 4,
      nombre: 'Nicolas',
      email: 'betprime@workin.com',
      empresa: 'Betprime',
      rol: 'user',
      status: 'active',
      fechaCreacion: '27/2/2025'
    },
    {
      id: 5,
      nombre: 'Manpower',
      email: 'Manpower@demo.com',
      empresa: 'Manpower',
      rol: 'user',
      status: 'active',
      fechaCreacion: '12/2/2025'
    },
    {
      id: 6,
      nombre: 'Manpower',
      email: 'Manpower@prueba.com',
      empresa: 'Manpower',
      rol: 'user',
      status: 'active',
      fechaCreacion: '12/2/2025'
    },
    {
      id: 7,
      nombre: 'UCAL',
      email: 'leacosta@ucal.edu.pe',
      empresa: 'UCAL',
      rol: 'user',
      status: 'active',
      fechaCreacion: '3/2/2025'
    },
    {
      id: 8,
      nombre: 'Jessica Herrera',
      email: 'jherrera@capitale.pe',
      empresa: 'Capitale',
      rol: 'user',
      status: 'inactive',
      fechaCreacion: '31/1/2025'
    },
    {
      id: 9,
      nombre: 'Diego Rodriguez',
      email: 'prueba@prueba.com',
      empresa: 'Prueba',
      rol: 'user',
      status: 'active',
      fechaCreacion: '27/1/2025'
    },
    {
      id: 10,
      nombre: 'Lock R&I',
      email: 'mreyes@lockyasociados.com',
      empresa: 'Lock Research & Insights',
      rol: 'user',
      status: 'active',
      fechaCreacion: '24/1/2025'
    },
    {
      id: 11,
      nombre: 'Francesco Lucchesi',
      email: 'francesco@workin2.com',
      empresa: '—',
      rol: 'admin',
      status: 'active',
      fechaCreacion: '24/1/2025'
    },
    {
      id: 12,
      nombre: 'Dani',
      email: 'dani@gmail.com',
      empresa: 'AJE',
      rol: 'user',
      status: 'active',
      fechaCreacion: '23/1/2025'
    },
    {
      id: 13,
      nombre: 'Diego Rodriguez',
      email: 'diego@workin2.com',
      empresa: '—',
      rol: 'admin',
      status: 'active',
      fechaCreacion: '23/1/2025'
    },
    {
      id: 14,
      nombre: 'Usuario Lock Research',
      email: 'lock@research.com',
      empresa: 'Lock Research & Insights',
      rol: 'user',
      status: 'active',
      fechaCreacion: '23/1/2025'
    },
    {
      id: 15,
      nombre: 'XTIAN Admin',
      email: 'x@portal-labs.tech',
      empresa: '—',
      rol: 'admin',
      status: 'active',
      fechaCreacion: '23/1/2025'
    }
  ]);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Usuarios</h1>
          <p className="mt-1 text-sm text-gray-500">
            Lista de usuarios de MyWorkin
          </p>
        </div>
        <button className="inline-flex items-center px-4 py-2 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900">
          <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
          Nuevo usuario
        </button>
      </div>

      <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-white">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nombre
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Empresa
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Rol
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha de creación
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {usuarios.map((usuario) => (
              <tr key={usuario.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {usuario.nombre}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {usuario.email}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {usuario.empresa}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    usuario.rol === 'admin' 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-gray-100 text-gray-800'
                  }`}>
                    {usuario.rol}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    usuario.status === 'active'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-gray-100 text-gray-800'
                  }`}>
                    {usuario.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {usuario.fechaCreacion}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <button className="text-gray-600 hover:text-gray-900">
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Usuarios; 